// import React from 'react';
// // import AppProvider from "../../../Components/bootstrap"
// import Typography from '@material-ui/core/Typography';
// import Paper from '@material-ui/core/Card';
// import { makeStyles } from "@material-ui/core/styles";
// import RecentFeedback from "../../../Screens/MentorProfile/Components/recentFeedback"
// const useStyles = makeStyles(theme => ({
//     "@global": {
//       body: {
//         backgroundColor: "#F7F7F7",
//       }
//     },
//     Avatar:{
//         height:"35px"
//     }
// }));
// export default function MentorProfile(handleSubmit,
//     reset,
//     submitting,
//     pristine,
//     values,  
//     props,
//     ...rest) {
//     const classes = useStyles();
     

//     return (
//         <div className={classes.div} >
//             <form onSubmit={handleSubmit} noValidate>
//                 <div style={{paddingLeft:"4%",paddingRight:"4%",}}>           
//                 <Paper style={{padding:"15px",boxShadow:"none"}}>
//                 <Typography varinat="h6" style={{marginTop:"40px",fontWeight:"540"}}>Description</Typography>
//                 <Typography variant="body2" style={{marginTop:"10px",opacity:"0.7"}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
//                     Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
//                     Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum
//                  </Typography>

//                 <Typography varinat="h6" style={{marginTop:"40px",fontWeight:"540"}}>Charges</Typography>
//                 <Typography variant="body2" style={{marginTop:"10px",opacity:"0.7"}}>
//                     Rs 700 for 30 min session
//                  </Typography>
//                     {
//                         <RecentFeedback />
//                     }
//                 <Typography varinat="h6" style={{marginTop:"40px",fontWeight:"540"}}>Certifications</Typography>
//                 <Typography variant="body2" style={{marginTop:"10px",opacity:"0.7"}}>
//                 Certification 1, Certification 2, ...  
//                </Typography>
//                 </Paper>
//             </div>
//             </form>
//          </div>
//     );
// }



import React from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Card';
// import { makeStyles } from "@material-ui/core/styles";
import RecentFeedback from "../../../Screens/MentorProfile/Components/recentFeedback"
import { useMentorProfileData } from "../../ScheduleAppointment/hooks"
import { useParams } from "react-router"
// const useStyles = makeStyles(theme => ({
//     "@global": {
//         body: {
//             backgroundColor: "#F7F7F7",
//         }
//     },
//     Avatar: {
//         height: "35px"
//     }
// }));
const MentorProfile=(handleSubmit,
        reset,
        submitting,
        pristine,
        values,  
        props,
        ...rest)=> {
    // const classes = useStyles();
    const { mentorId } = useParams()
    const { mentorData } = useMentorProfileData(mentorId);
    console.log("mentorData",mentorData)
    if (mentorData.loading) return <p>Loading</p>
    if (mentorData.error) return <p>error</p>
    const { charge,description,Certification } = mentorData.data
    console.log("Certification",Certification)


    return (

            <div style={{paddingLeft:"4%",paddingRight:"4%",}}> 
            <form onSubmit={handleSubmit} noValidate>          
                <Paper style={{padding:"15px",boxShadow:"none"}}>
                <Typography varinat="h6" style={{marginTop:"40px",fontWeight:"540"}}>Description</Typography>
                <Typography variant="body2" style={{marginTop:"10px",opacity:"0.7"}}>{description}
                 </Typography>

                    <Typography varinat="h6" style={{ marginTop: "40px", fontWeight: "540" }}>Charges</Typography>
                    <Typography variant="body2" style={{ marginTop: "10px", opacity: "0.7" }}>
                        Rs. {charge } for 30 min session
                 </Typography>
                    <RecentFeedback />
                    <Typography var at="h6" style={{ marginTop: "40px", fontWeight: "540" }}>Certifications</Typography>
                    <Typography variant="body2" style={{ marginTop: "10px", opacity: "0.7" }}>
                        {Certification !== undefined ? Certification.map(certification => <span key={certification}>{certification}, </span>):""}
                    </Typography>
                </Paper>
                </form>
            </div>
    );
}

export default MentorProfile;